/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { hasOrganizationPermission, OrganizationPermission, OrganizationPermissions } from 'shared';

import { RootState } from '../store';

export const useOrganizationPermissions = (organizationId: string) => {
  const { user } = useSelector((state: RootState) => state.auth);

  return useMemo(() => {
    const roles = user?.organizations.find(organization => organization.id === organizationId)?.roles || [];
    return OrganizationPermissions.reduce(
      (acc, permission) => ({ ...acc, [permission]: hasOrganizationPermission(roles, permission) }),
      {} as Record<OrganizationPermission, boolean>,
    );
  }, [user, organizationId]);
};
